import $ from 'jquery';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');

	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
			}
		});
	}
	//console.log('value=', $('#header-nav a'));
	const $navs = $('#header-nav a');
	$.each( $navs, function(key, value) {
		$(value).html('<span>'+($(value).text())+'</span>');
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js